export const AP_CODE_NOT_IN_LZ_MESSAGE =
	'A kód alebo P kód nie je evidovaný v Lekárskej zóne. Prosím, kontaktujte OMR'

export const PENDING_AP_CODE_TOAST_KEY = 'mdx_pending_ap_code_toast'

export function persistPendingApCodeToast(message: string = AP_CODE_NOT_IN_LZ_MESSAGE) {
	sessionStorage.setItem(PENDING_AP_CODE_TOAST_KEY, message)
}

export function consumePendingApCodeToast(): string | null {
	const message = sessionStorage.getItem(PENDING_AP_CODE_TOAST_KEY)
	if (!message) return null
	sessionStorage.removeItem(PENDING_AP_CODE_TOAST_KEY)
	return message
}

export type LzApAccess = {
	id: number | string
	a_code?: string | null
	code?: string | null
	ambulance?: {
		pzs_id?: string | null
		[key: string]: unknown
	} | null
	[key: string]: unknown
}

export type LzApProvider = {
	id: number | string
	p_code?: string | null
	accesses?: LzApAccess[] | null
	[key: string]: unknown
}

export type ApCodePair = {
	aCode: string
	pCode: string
}

export type FindLzAccessByApCodeResult = {
	provider: LzApProvider
	access: LzApAccess
}

function normalizeApCode(value: unknown): string {
	return String(value ?? '')
		.trim()
		.toUpperCase()
}

function accessMatchesDoctorCode(access: LzApAccess, normalizedA: string): boolean {
	return (
		normalizeApCode(access.a_code) === normalizedA ||
		normalizeApCode(access.code) === normalizedA
	)
}

function accessMatchesPzsId(access: LzApAccess, normalizedP: string): boolean {
	return normalizeApCode(access.ambulance?.pzs_id) === normalizedP
}

export function parseApCodesFromParams(
	params: Record<string, unknown> | undefined
): ApCodePair | null {
	const aCode = normalizeApCode(params?.doctorCode ?? params?.a_code)
	const pCode = normalizeApCode(params?.providerCode ?? params?.p_code)

	if (!aCode && !pCode) return null

	return { aCode, pCode }
}

/**
 * CURO `providerCode` mapuje na ambulance.pzs_id (nie provider.p_code).
 * `doctorCode` mapuje na access.a_code / access.code.
 */
export function findLzAccessByApCode(
	providers: LzApProvider[] | null | undefined,
	aCode: string,
	pCode: string
): FindLzAccessByApCodeResult | null {
	const normalizedA = normalizeApCode(aCode)
	const normalizedP = normalizeApCode(pCode)

	if (!normalizedA || !normalizedP || !providers?.length) return null

	for (const provider of providers) {
		const access = provider.accesses?.find(
			(item) =>
				accessMatchesPzsId(item, normalizedP) &&
				accessMatchesDoctorCode(item, normalizedA)
		)

		if (access) {
			return { provider, access }
		}
	}

	return null
}
